module.exports = __webpack_public_path__ + "img/presentation_2.025f98a3.jpeg";